import React, { useState } from 'react';
import './RoleSelectionModal.css';
import { getAuthHeaders } from '../utils/auth';
import { getApiEndpoint } from '../utils/api';

const RoleSelectionModal = ({ isOpen, onRoleSelected }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  if (!isOpen) return null;

  const handleSelect = async (role) => {
    setLoading(true);
    setError('');
    try {
      const response = await fetch(getApiEndpoint('/api/auth/role'), {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
        body: JSON.stringify({ role }),
      });
      if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        throw new Error(data.detail || 'Failed to save role');
      }
      const updatedUser = await response.json();
      // Go straight to dashboard — the Onboarding flow handles profile seeding
      onRoleSelected(updatedUser, false, null);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // Role selection only — no profile seeding here
  return (
    <div className="role-modal-overlay">
      <div className="role-modal">
        <div className="role-modal-header">
          <h2>Welcome to Mnevia!</h2>
          <p>Tell us about your role so we can personalise your experience.</p>
        </div>

        {error && <div className="role-modal-error">{error}</div>}

        <div className="role-cards">
          <button
            className="role-card"
            onClick={() => handleSelect('pi')}
            disabled={loading}
          >
            <div className="role-card-icon">🔬</div>
            <h3>Principal Investigator</h3>
            <p>I lead a lab or research group, manage team members, and oversee projects.</p>
            <span className="role-card-tag">PI</span>
          </button>

          <button
            className="role-card"
            onClick={() => handleSelect('ic')}
            disabled={loading}
          >
            <div className="role-card-icon">📄</div>
            <h3>Individual Contributor</h3>
            <p>I'm a researcher, student, or postdoc focused on my own work and literature review.</p>
            <span className="role-card-tag">IC</span>
          </button>
        </div>

        {loading && <p className="role-modal-loading">Saving…</p>}
      </div>
    </div>
  );
};

export default RoleSelectionModal;
